import {
  SET_MARKETING
} from 'app/actions/types';

import {
  getMarketing as getMarketingSvc,
  uploadSignMarketingImage as uploadSignMarketingImageSvc
} from 'app/services/marketing';

import {
  uploadFile as uploadFileSvc
} from 'shared/services/FileService';

export const getMarketing = params => async dispatch => {
  let marketing = await getMarketingSvc(params);

  if (marketing) {
    dispatch({
      type: SET_MARKETING,
      payload: marketing.params
    });
  }

  return marketing;
}

export const setMarketingParams = params => async dispatch => {
  dispatch({
    type: SET_MARKETING,
    payload: params
  });
}
